import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import echarts from 'echarts'
import VueCookies from 'vue-cookies'
import XLSX from 'xlsx'



axios.defaults.headers.get['Content-Type']='application/json;charset=UTF-8';
axios.defaults.baseURL='http://36.22.191.66:4005/'
// axios.defaults.baseURL='http://localhost:15497',
// axios.defaults.baseURL='http://36.22.191.66:4005'
// axios.defaults.baseURL='http://36.22.191.66:4005'

Vue.prototype.$axios=axios;
Vue.prototype.$echarts=echarts;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$http = axios
Vue.use(VueCookies)
Vue.use(XLSX)

store.state.token = VueCookies.get("user_token")


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app")
